import React, { useState, useEffect } from "react";
import { FaAngleUp } from "react-icons/fa";
import "./indexttb.css";


const ScrollToTop = () => {
    const [showTopBtn, setShowTopBtn] = useState(false);
    useEffect(() => {
        document.addEventListener('scroll', () => {
       
            try{           
                if(document.querySelector('#article-id').getBoundingClientRect().top<-3000){
                    setShowTopBtn(true)
                }else{
                    setShowTopBtn(false)
                }
            }catch{
                setShowTopBtn(true)
            }
            

        });

    }, []);

    function goToTop() {

        window.scroll({
            top: 0,
            behavior: 'smooth'
          });
       
    };

   
    return (
        <div className="top-to-btmTG">
            {showTopBtn ? <FaAngleUp  className="icon-positionTG icon-styleTG" onClick={() => goToTop()} /> :""}
        </div>
    );
};
export default ScrollToTop;